<template>
    <div class="add-fence">

        <!-- 上方搜索 -->
        <div class="seach-box">
            <div class="seach df-al-c">
                <!-- <input class="seach-input" v-model="keyword" type="text" placeholder="输入地址快捷定位" @focus="showSeachModal = true"> -->
                <van-search class="seach-input" v-model="keyword" :left-icon="require('@/assets/images/safety-fence/search@2x.png')" background="#f2f2f2" placeholder="输入地址快捷定位" @focus="showSeachModal = true" />
                <i class="back-text" @click="back">取消</i>
            </div>
            <ul class="list" v-show="addressList.length>0 && showList">
                <li class="item" v-for="(item, index) in addressList" :key="index" @click="selectAddress(item)">
                    <p class="title">{{item.title}}</p>
                    <span class="info-address x-overflow-hidden">{{item.address}}</span>
                </li>
                <li class="last">以显示完全</li>
            </ul>
            <van-overlay :show="showSeachModal" @click="showSeachModal = false" />
        </div>

        <!-- 地图 -->
        <div class="map" id="fenceMap"></div>

        <!-- 添加围栏 -->
        <div class="add-form">
            <div class="title">区域名称   <span class="radius">当前半径： {{postData.radius}}米</span></div>
            <div class="df-al-c">
                <input class="com-border-input name-input" @blur.prevent="solveFixd()" v-model="postData.fenceName" type="text" placeholder="例如：家附近">
                <van-button class="com-solid-btn" type="info" @click="clickSave">保存</van-button>
            </div>
            <p v-if="postData.address" class="address com-overflow-two">{{postData.address}}</p>
        </div>

        <!-- 滑块控件 -->
        <div class="fence-slider">
            <div class="control iconfont iconlarge" @click="addRadius"></div>
            <div class="slider">
                <van-slider v-model="radius" inactive-color="#5193FF" active-color="#D6DDE9" :step="-1" :min="100" :max="5000" vertical @change="sliderChange">
                    <div slot="button" class="custom-button"></div>
                </van-slider>
            </div>
            <div class="control iconfont iconsmall" @click="reduceRadius"></div>
        </div>
    </div>
</template>

<script>
/**
 * 输入实时搜索节流方法
 * @param {Function} func 输入完成的回调函数
 * @param {Number} delay 延迟时间
 */
const debounce = (func, delay) => {
    let timer;
    return (...args) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
};

export default {

    data() {
        return {
            keyword: '', // 搜索字段
            showSeachModal: false, // 是否显示搜索遮罩
            showList: false, // 是否显示结果列表
            map: null, // 地图实例
            circle: null, // 圆实例
            marker: null, // 点标注实例
            radius: 5000, // 半径
            centerPoint: null,
            addressList: [], // 搜索地址列表

            postData: {
                shape: 'circle', // 默认圆形
                mapType: 'baidu', // 地图类型
                fenceId: null, // 围栏id
                fenceName: '', // 围栏名称
                longitude: 114.064552,
                latitude: 22.548456,
                radius: 100, // 半径
                address: '', // 地址
            }
        };
    },

    created() {
        if (this.$route.query.data) {
            let data = JSON.parse(this.$route.query.data);
            let lat_lng = JSON.parse(data.fenceJson)
            this.postData.fenceId = data.fenceId; // 围栏id
            this.postData.fenceName = data.fenceName; // 围栏名称
            this.postData.radius = data.radius; // 围栏半径
            this.postData.address = data.addr; // 围栏地址
            this.postData.longitude = lat_lng[0].lon; // 经度
            this.postData.latitude = lat_lng[0].lat; // 纬度
        }

        this.radius = Math.abs(this.postData.radius - 5000 - 100);
    },

    mounted() {
        let point = new BMap.Point(this.postData['longitude'], this.postData['latitude']);  // 经度(lng)在前, 纬度(lat)在后

        this.circle = this.addCircle(point, this.postData.radius); // 创建圆形覆盖物

        this.marker = this.addMarker(point); // 创建点标注

        this.initMap(point); // 初始化地图

        this.map.addOverlay(this.circle); // 添加到地图

        this.map.addOverlay(this.marker); // 添加到地图

        this.setViewport(this.circle); // 自动计算最优的地图层级

        this.map.setCenter(point); // 设置中心点

        if (!this.postData.fenceId) { // 不是编辑状态需要定位, 并且解析地址

            this.getLocation(point => { // 获取当前位置

                this.map.panTo(point); // 以动画移动到定位点

                this.map.setCenter(point); // 设置中心点

                this.centerPoint = point; // 设置中心点

                this.getAddress(point, res => { // 根据点解析地址
                    this.postData.address = res.address;
                });

            }, () => {
                this.$toast({
                    message: '定位失败',
                    duration: 1000,
                    icon: require('@/assets/images/safety-fence/wrong.png')
                });
            });
        }

        /**
         * 监听标注拖拽事件
         */
        // this.marker.addEventListener('dragging', (e) => {
        //     this.map.removeOverlay(this.circle); // 先清除已有圆形覆盖物,否则拖动会出现残影
        //     this.circle.setCenter(e.point); // 设置圆形中心点
        //     this.map.addOverlay(this.circle); // 添加到地图
        // });

        /**
         * 监听标注拖拽完成事件
         */
        // this.marker.addEventListener('dragend', (e) => {
        //     this.centerPoint = e.point; // 设置中心点
        //     this.getAddress(e.point, res => { // 根据点解析地址
        //         this.postData.address = res.address;
        //     });
        // });
        
        // TODO: 触摸移动时触发此事件 此时开启可以拖动。虽然刚初始化该地图不可以拖动，但是可以触发拖动事件。
        this.map.addEventListener("touchmove",  (e)=> {
          this.map.enableDragging();
        });
        // TODO: 触摸结束时触发次此事件  此时开启禁止拖动
        this.map.addEventListener("touchend", (e)=> {
          this.map.disableDragging();
        });

        /**
         * 监听地图点击事件
         */
        this.map.addEventListener('click', (e) => {
            if (!e.overlay) {
                this.centerPoint = e.point; // 设置中心点
                this.getAddress(e.point, res => { // 根据点解析地址
                    this.postData.address = res.address;
                });
            }
        });

        /**
         * 智能搜索
         */
        let seach = new BMap.LocalSearch(this.map, {
            onSearchComplete: res => {
                console.log(res, 552)
                if (res) {
                    for (let key in res) {
                        if (Object.prototype.toString.call(res[key]) === "[object Array]") {
                            if (res[key].length > 0) {
                                this.addressList = res[key];
                            }
                        }
                    }
                    // this.addressList = res.Ir;
                    this.showList = true;
                } else {
                    this.addressList = [];
                    this.showList = false;
                }
            }
        });

        /**
         * 节流实时搜索
         */
        this.$watch('keyword', debounce(val => {
            seach.search(val);
        }, 200));
    },

    methods: {
        /**
       * 获取焦点时处理iphone不能点击的BUG
       */
        solveFixd() {
            window.scrollTo(0, 0)
        },
        /**
         * 点击保存
         */
        clickSave() {

            if (!this.postData.fenceName) {
                this.$toast({
                    message: '请输入区域名称',
                    duration: 600
                });
                return;
            }

            let reg = /^([\u4E00-\u9FA5A-Za-z0-9]){1,20}$/;
            if (!reg.test(this.postData.fenceName)) {
                this.$toast({
                    message: '只限输入中文、字母、数字，20字符以内',
                    duration: 600
                });
                return;
            }

            this.addFence(this.postData);
        },

        /**
         * 新增或修改围栏
         * @param {类型} 参数名 参数注释
         */
        addFence(postData) {
            // const latLng = this.$gps.baiduToChina(
            //     postData.longitude,
            //     postData.latitude,
            // )
            // postData['latitude'] = latLng['lng']
            // postData['longitude'] = latLng['lat']
            // postData = Object.assign(latLng, postData)
            let lat_lng ={
                lat:this.postData.latitude,
                lon:this.postData.longitude
            };
            console.log(this.postData.latitude,this.postData.longitude,999)
            let locationStr = JSON.stringify([lat_lng]);
            let data = {
                ver: 1,
                method: this.postData.fenceId?'updateFence':'addFence',
                fenceType:this.postData.radio,
                fenceName:this.postData.fenceName,
                shape:'circle',
                fenceRadius:this.postData.radius,
                fenceJson:locationStr,
                fenceSetup:0,
                fenceId:this.postData.fenceId?this.postData.fenceId:''
            };
            this.$http.post(this.$api.userInfo.POST_APPLET, data).then(res => {
                if (res.code === 0) {
                    this.$toast({
                        message: postData.fenceId?'修改成功':'保存成功',
                        duration: 1000,
                        icon: require('@/assets/images/safety-fence/correct.png')
                    });

                    this.$router.push('/safetyFence');
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            });
        },

        /**
         * 滑块改变事件
         * @param {Number} val 返回当前滑块值
         */
        sliderChange(val) {
            this.changeCircle(val);
        },

        /**
         * 根据半径改变圆形覆盖物
         * @param {Number} radius 半径
         */
        changeCircle(radius) {
            this.postData.radius = Math.abs(radius - 5000 - 100);
            this.circle.setRadius(this.postData.radius); // 设置圆形半径
            this.setViewport(this.circle); // 自动计算最优的地图层级
        },

        /**
         * 初始化地图
         * @param {Object} point 点
         */
        initMap(point) {
            this.map = new BMap.Map('fenceMap');
            this.map.centerAndZoom(point, 16);
            this.map.disableDoubleClickZoom(); // 禁止双击放大
        },

        /**
         * 定位当前位置
         * @param {Function} success 成功回调
         * @param {Function} error 错误回调
         */
        getLocation(success, error) {
            let geolocation = new BMap.Geolocation(); // 创建定位实例
            geolocation.getCurrentPosition((res) => {
                if (geolocation.getStatus() == BMAP_STATUS_SUCCESS) { // 定位成功
                    let centerPoint = new BMap.Point(res.longitude, res.latitude); // 定位当前点
                    success(centerPoint);
                } else {
                    error();
                }
            }, { enableHighAccuracy: true }); // enableHighAccuracy 要求浏览器获取最佳结果
        },

        /**
         * 根据点坐标解析地址
         * @param {Object} point 点
         * @param {Function} callBack 回调方法
         */
        getAddress(point, callBack) {
            let geocoder = new BMap.Geocoder();
            geocoder.getLocation(point, res => {
                callBack(res);
            });
        },

        /**
         * 根据圆形覆盖物设置地图视野
         * @param {Object} circle 圆形覆盖物实例
         */
        setViewport(circle) {
            let round = circle.getBounds(); // 获取圆形地理区域
            let arr = []
            for (let key in round) {
                if (Object.prototype.toString.call(round[key]) === "[object Object]") {
                    arr.push(round[key])
                }
            }
            let zoom = this.map.getViewport([arr[0], arr[1]]).zoom;
            let center = this.map.getViewport([arr[0], arr[1]]).center;
            this.map.panTo(center); // 以动画移动到定位点
            this.map.setCenter(center); // 设置中心点
            this.map.setZoom(zoom); // 设置层级
        },

        /**
         * 添加标注
         * @param {Object} point 点坐标
         */
        addMarker(point) {
            let icon = new BMap.Icon(require('@/assets/images/moren_tubiao.png'), new BMap.Size(30, 40), {
                imageSize: { width: 30, height: 40 } // 图片大小
            });
            let marker = new BMap.Marker(point, { icon: icon }); // 创建标注
            marker.setZIndex(2);
            // marker.enableDragging(); // 可拖拽
            return marker; // 返回标注点的实例
        },

        /**
         * 添加圆形
         * @param {Object} point 点坐标
         * @param {Number} radius 半径
         */
        addCircle(point, radius) {
            let circle = new BMap.Circle(point, radius, {
                strokeColor: '#0067B5',
                strokeWeight: 1,
                fillOpacity: 0.4,
                fillColor: '#0067B5',
                strokeOpacity: 0.2
            });
            return circle; // 返回圆形的实例
        },

        /**
         * 返回-取消
         * @param {类型} 参数名 参数注释 
         */
        back() {
            if (this.showList || this.showSeachModal) {
                this.showList = false;
                this.keyword = '';
                this.addressList = [];
                this.showSeachModal = false;
                return;
            }
            this.$router.push('/safetyFence');
        },

        /**
         * 选中搜索的地址
         * @param {Object} obj 当前点击的地址数据
         */
        selectAddress(obj) {
            this.hideResList();
            this.showSeachModal = false;
            this.postData.address = obj.address || obj.title; // 详细地址
            this.centerPoint = obj.point; // 中线点
        },

        /**
         * 显示搜索结果
         * @param {类型} 参数名 参数注释
         */
        showResList() {
            this.showList = true;
        },

        /**
         * 隐藏搜索结果
         * @param {类型} 参数名 参数注释
         */
        hideResList() {
            this.showList = false;
        },

        /**
         * 增加半径 (因为是倒转过来的,所以算法是反的)
         */
        addRadius() {
            if (this.radius === 100) {
                return;
            }
            this.radius -= 20;
            if (this.radius < 100) {
                this.radius = 100;
                return;
            }
            this.changeCircle(this.radius);
        },

        /**
         * 减少半径 (因为是倒转过来的,所以算法是反的)
         */
        reduceRadius() {
            if (this.radius === 5000) {
                return;
            }
            this.radius += 20;
            if (this.radius > 5000) {
                this.radius = 5000;
            }
            this.changeCircle(this.radius);
        }
    },

    watch: {

        /**
         * 监测中心点变化
         */
        centerPoint: {
            handler(val) {
                this.map.panTo(val); // 以动画移动到定位点
                this.map.setCenter(val); // 设置中心点
                this.marker.setPosition(val); // 设置点标注中心点
                this.map.removeOverlay(this.circle); // 先清除已有圆形覆盖物,否则拖动会出现残影
                this.circle.setCenter(val); // 设置圆形中心点
                this.map.addOverlay(this.circle); // 添加到地图
                this.postData.latitude = val.lat; // 赋值给需要提交的参数
                this.postData.longitude = val.lng; // 赋值给需要提交的参数
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.com-solid-btn {
    width: 150px;
    height: 68px;
    border-radius: 10px;
    border: 0 none;
    font-size: 32px;
    line-height: 68px;
    background-color: #01ADA9;
    border-radius: 40px;
}

.com-border-input {
    height: 68px;
    font-size: 28px;
    padding-left: 15px;
    border-radius: 8px;
    border: 1px solid #d6dde9;
}

// 超出两行显示省略号
.com-overflow-two {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.add-fence {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;

    // 顶部搜索框
    .seach-box {
        position: fixed;
        top: 0;
        z-index: 3;
        width: 100%;

        // 搜索栏
        .seach {
            position: relative;
            z-index: 2;
            width: 100%;
            height: 80px;
            background-color: #fff;

            // 输入框
            .seach-input {
                flex: 1;
                height: 60px;
                margin-left: 30px;
                padding: 0 10px;
                border-radius: 8px;

                .van-search__content {
                    padding-left: 10px;
                    background-color: transparent;
                }
            }

            // 返回文字
            .back-text {
                width: 120px;
                height: 100%;
                line-height: 80px;
                font-size: 32px;
                color: #333;
                text-align: center;
            }
        }

        // 搜索列表
        .list {
            box-sizing: border-box;
            position: fixed;
            top: 80px;
            bottom: 0;
            z-index: 2;
            width: 100%;
            overflow-y: auto;

            .item {
                position: relative;
                overflow: hidden;
                padding: 24px 36px;
                color: #999;
                font-size: 24px;
                background-color: #fff;

                &:after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 30px;
                    width: 695px;
                    height: 1px;
                    background-color: #d6dde9;
                }

                &:active {
                    background-color: #f8f8f8;
                }

                .title {
                    margin-bottom: 16px;
                    color: #333;
                    font-size: 28px;
                }

                .info-address {
                    display: block;
                }
            }

            .last {
                padding: 38px 0;
                text-align: center;
                color: #999;
                background-color: #fff;
            }
        }
    }

    // 地图
    .map {
        width: 100%;
        height: 100%;
    }

    // 添加围栏框
    .add-form {
        box-sizing: border-box;
        position: fixed;
        bottom: 16px;
        left: 2%;
        width: 96%;
        padding: 32px;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 8px 0px #00000033;

        .title {
            font-size: 32px;

            .radius {
                margin-left: 20px;
                font-size: 24px;
                color: #666;
            }
        }

        .name-input {
            flex: 1;
            margin: 32px 16px 32px 0;
            border-radius: 40px;
        }

        .address {
            font-size: 24px;
            line-height: 36px;
            color: #666;
        }
    }

    // 滑块样式
    .fence-slider {
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: fixed;
        top: 160px;
        right: 16px;
        z-index: 2;
        width: 80px;
        height: 468px;
        background-color: #fff;
        box-shadow: 0px 0px 8px 0px #00000033;
        border-radius: 36px;
        // 加减控件
        .control {
            width: 80px;
            height: 80px;
            color: #333;
            font-size: 40px;
            text-align: center;
            line-height: 80px;
        }

        // 中间滑块
        .slider {
            flex: 1;
            padding: 10px 0;
            overflow: hidden;
            text-align: center;

            .custom-button {
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background-color: #5193ff;
            }
        }
    }
}
</style>

<style lang="scss">
.add-fence {
    .van-slider__button-wrapper {
        right: 2px;
    }

    .van-slider__button-wrapper::after {
        width: 80px;
        height: 80px;
        left: -40px;
        top: -40px;
        transform: translate(8px, 8px);
    }
}
</style>